import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 78.55 20.49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M37.14 13.77 0 20.49h78.55c0-2.66-2.54-5.53-8.62-5.5h-3.4a2.267 2.267 0 0 1-3.87 2.33c-.73-1.01-.5-2.43.51-3.15l4.95-3.28c4.64-2.94 4.18-7.25-2.17-7.64L13.73 0s16.6 5.14 25.31 8.38c4.95 1.84 3.98 4.37-1.9 5.39",
      style: {"fill":"#0081c6"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "AR-logo"}) } }